import { render, staticRenderFns } from "./personaSenility.vue?vue&type=template&id=a378c9fa&scoped=true&"
import script from "./personaSenility.vue?vue&type=script&lang=js&"
export * from "./personaSenility.vue?vue&type=script&lang=js&"
import style0 from "./personaSenility.vue?vue&type=style&index=0&id=a378c9fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a378c9fa",
  null
  
)

export default component.exports